import {
    ReportRequestForm,
    ReportResponseForm,
    ReportSpecForm,
    RowIndex,
    validateGroupOption,
} from 'src/app/core/models/report';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ReportService extends ApiService {
    /**
     * Frontend validation of request. Should be moved to an SDK together with the types and API services.
     * @param requestData
     * @private
     */
    private validateRequest(requestData: ReportRequestForm): string[] {
        const errors: string[] = [];
        requestData.reports.forEach((report: ReportSpecForm) => {
            if (!report.groupBy || report.groupBy.length < 1) {
                errors.push('field "groupBy" must not be empty. You must at least group by one column!');
            }
            if (!validateGroupOption(report.groupBy)) {
                errors.push('field "groupBy" contains unsupported values');
            }
        });
        return errors;
    }

    public getReport(requestData: ReportRequestForm): Observable<ReportResponseForm> {
        // console.log("ReportService Request:\n" + JSON.stringify(requestData, null, 2));
        const errors = this.validateRequest(requestData);
        if (errors.length > 0) {
            console.error('report service request validation failed:');
            console.error(errors);
        }
        return this._http.post<ReportResponseForm>(ApiService.openApiUrl + `report`, requestData).pipe(
            map((response: ReportResponseForm): ReportResponseForm => {
                // make sure that the seconds are numbers, not strings; no matter what type the JSON transport is:
                response.reports.forEach((report) => {
                    report.totalSeconds = Number(report.totalSeconds);
                    report.rows.forEach((row) => {
                        row[RowIndex.SECONDS] = Number(row[RowIndex.SECONDS]);
                    });
                });
                return response;
            }),
        );
    }
}
